import React from 'react'

const ExcelReportIcon = () => {
    return (
        <svg
            width="35"
            height="35"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3832_4329)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.08015 0.90625H15.1123L21.9093 8.00114V21.7792C21.9093 23.5048 20.5167 24.9062 18.7911 24.9062H7.08015C5.36337 24.9062 3.96191 23.5048 3.96191 21.7792V4.02449C3.96188 2.3077 5.36337 0.90625 7.08015 0.90625Z"
                    fill="#00733B"
                />
                <path
                    opacity="0.302"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1025 0.90625V7.93983H21.9084L15.1025 0.90625Z"
                    fill="#00733B"
                />
                <path
                    d="M11.424 18.3824H10.2591L9.46202 17.0423L8.66493 18.3824H7.49121L8.87517 16.0524L7.65766 14.0291H8.83135L9.46199 15.0802L10.0839 14.0291H11.2576L10.0488 16.0612L11.424 18.3824ZM11.8357 18.3824V14.0291H12.9481V17.4364H14.8401V18.3824H11.8357V18.3824ZM16.6795 18.4349C16.2415 18.4349 15.8562 18.2948 15.5233 18.0233C15.1992 17.7605 15.0153 17.4276 14.989 17.0335L15.9438 16.7532C15.9701 16.9634 16.0576 17.1474 16.2066 17.2875C16.3642 17.4277 16.5394 17.4977 16.7321 17.4977C16.8898 17.4977 17.0211 17.4627 17.1262 17.3926C17.2226 17.3225 17.2751 17.2262 17.2751 17.1123C17.2751 17.016 17.2313 16.9371 17.1525 16.8671C17.0737 16.8058 16.9686 16.7532 16.8459 16.7094C16.7233 16.6656 16.5744 16.6218 16.4255 16.5868C16.2678 16.543 16.1102 16.4904 15.9613 16.4204C15.8036 16.3591 15.6635 16.2802 15.5408 16.1839C15.4094 16.0963 15.3131 15.9649 15.2342 15.7985C15.1554 15.6408 15.1116 15.4481 15.1116 15.2291C15.1116 14.87 15.2605 14.5722 15.5671 14.3357C15.8737 14.0904 16.2415 13.9766 16.6707 13.9766C17.0999 13.9766 17.4765 14.0817 17.7919 14.2831C18.1072 14.4933 18.3087 14.7649 18.3875 15.0977L17.389 15.5182C17.3452 15.3342 17.2576 15.1853 17.1349 15.0715C17.0123 14.9664 16.8547 14.9051 16.6707 14.9051C16.5306 14.9051 16.4255 14.9401 16.3379 14.9927C16.259 15.0452 16.224 15.1241 16.224 15.2204C16.224 15.308 16.2766 15.3868 16.3817 15.4481C16.4868 15.5007 16.6269 15.5445 16.7846 15.5708C16.9422 15.597 17.1174 15.6408 17.3014 15.7021C17.4941 15.7722 17.6605 15.8423 17.8269 15.9386C17.9846 16.0262 18.116 16.1751 18.2211 16.3678C18.3349 16.5693 18.3875 16.8058 18.3875 17.0773C18.3875 17.4803 18.2298 17.8131 17.9145 18.0583C17.5991 18.3036 17.1876 18.4349 16.6795 18.4349Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_3832_4329">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.935547 0.90625)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ExcelReportIcon
